const d3 = require("d3");

class TransitionCircleVisualiser {
    constructor(transitionPaths, transitionCirclesGroup, resourceNodes, projectNodes) {
        this.transitionCount = 0;
        this.transitionPaths = transitionPaths;
        this.transitionCirclesGroup = transitionCirclesGroup;
        this.resourceNodes = resourceNodes;
        this.projectNodes = projectNodes;

        this.transitions = [];
    }

    getTransitions(metrics) {
        var waitingTimesPerGroup = metrics.waitingTimesPerGroupHours;
        var transitionCircles = [];

        var increase = 8;

        Object.entries(waitingTimesPerGroup).forEach(([group1, group1list]) => {
            Object.entries(group1list).forEach(([group2, value]) => {
                if(value > 0 && (group1 == "X" || group2 == "X"))
                    value = 1;

                for (let i = 0; i < value / increase; i++) {
                    transitionCircles.push({ group1, group2, value, transitionCount: this.transitionCount, started: false, delay: i * 100 });
                    this.transitionCount += 1;
                }
            });
        });

        return transitionCircles;
    }

    getTransitionCircleStartPos(transition) {
        if (transition.group1 == "X") {
            return this.projectNodes[0];
        }

        return this.resourceNodes[transition.group1];
    }

    updateCircles(metrics, visualPathGroups) {
        var transitionCircles = this.getTransitions(metrics);
        this.transitions = this.transitions.concat(transitionCircles);

        var self = this;

        this.transitionCirclesGroup
            .selectAll("circle")
            .data(this.transitions)
            .enter()
            .append("circle")
            .attr("id", "travel")
            .style("stroke-width", 1)
            .style("stroke-opacity", 1)
            .style("stroke", "black")
            .style("fill", (d) => { if(d.group1 == "X" || d.group2 == "X") return "black"; return this.resourceNodes[d.group1].color; })
            .attr("transform", (d) => {
                var pos = self.getTransitionCircleStartPos(d);
                return "translate(" + pos.x + "," + pos.y + " )";
            })
            .attr("r", (d) => {
                if(d.group1 == "X" || d.group2 == "X")
                    return 5;

                var value = parseInt(visualPathGroups[d.group1 + d.group2].select("path").style("stroke-width").match(/\d+/)[0]);
                return value / 2;
            })

        d3.selectAll("#travel")
            .attr("r", (d) => {
                if(d.group1 == "X" || d.group2 == "X")
                    return 5;
                var value = parseInt(visualPathGroups[d.group1 + d.group2].select("path").style("stroke-width").match(/\d+/)[0]);
                return value / 2;
            })

        d3.selectAll("#travel")
            .filter((d) => !d.started)
            .transition()
            .style("opacity", 1)
            .delay((d) => d.delay)
            .duration(function (d) {

                d.started = true;
                return 1000;
                console.log(d.group1 + d.group2, self.transitionPaths[d.group1 + d.group2])
                var path = self.transitionPaths[d.group1 + d.group2].node();
                return path.getTotalLength() * 5;
            })
            .attrTween("transform", (d, i) => self.translateAlong(d)())
            .ease(d3.easeLinear)
            .on("end", function (d) {
                d3.select(this).remove();
                self.transitions.splice(self.transitions.indexOf(d), 1);
            });
    }

    translateAlong(mypath) {
        mypath = this.transitionPaths[mypath.group1 + mypath.group2];
        var length = mypath.node().getTotalLength();
        return () => {
            return (x) => {
                var p = mypath.node().getPointAtLength(x * length);
                return "translate(" + p.x + "," + p.y + ")";
            };
        };
    }
}

export { TransitionCircleVisualiser };